import React from 'react';
import PortalModal from '../../Common/Modal/PortalModal';
import { XMarkIcon, TrashIcon } from '@heroicons/react/24/outline';

const DeleteConfirmationModal = React.forwardRef(({ onConfirm, hideModal }, ref) => {
    return (
        <PortalModal
            id="delete-confirmation-modal"
            layout={false}
            ref={ref}>
            <div className="bg-white rounded-lg shadow-xl max-w-md mx-auto overflow-hidden">
                <div className="flex justify-between items-center bg-error p-4 text-white">
                    <h1 className="text-xl font-bold">Confirmation de suppression</h1>
                    <button 
                        onClick={hideModal}
                        className="text-white hover:text-base-300 hover:bg-base-100/20 rounded-full transition-all duration-200 focus:outline-none"
                    >
                        <XMarkIcon className="h-6 w-6" />
                    </button>
                </div>
                
                <div className="p-6">
                    <div className="mb-6">
                        <div className="flex justify-center mb-4">
                            <TrashIcon className="h-12 w-12 text-error" />
                        </div>
                        <p className="text-center mb-4">Êtes-vous sûr de vouloir supprimer les capsules sélectionnées ?</p>
                        <p className="text-sm text-gray-500 text-center">Cette action est irréversible.</p>
                    </div>

                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <button 
                            className="btn btn-ghost"
                            onClick={hideModal}
                        >
                            Annuler
                        </button>
                        <button 
                            className="btn btn-error"
                            onClick={onConfirm}
                        >
                            Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </PortalModal>
    );
});

export default DeleteConfirmationModal;
